import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProductRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.product_master_create === true ||
    permissions.product_master_edit === true ||
    permissions.product_master_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default ProductRouteMiddleware;
